module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// /Users/Mee/Desktop/annual-summary-2017/node_modules/axios/index.js
// module id = U+L7
// module chunks = 0